module.exports = __webpack_public_path__ + "img/main_dashboard.c1b45da1.svg";